export const state = () => ({
	theme: 'theme-light',
	university_theme: {
		logo: require('~~/assets/images/gradlinc/logo.svg'),
		logoDark: require('~~/assets/images/gradlinc/logo-dark.svg'),
		logoFull: require('~~/assets/images/gradlinc/logo-full-dark.svg'),
		logoFullDark: require(`~~/assets/images/gradlinc/logo-full-dark.svg`),
		primary: '8,62,127',
		primaryDark: '210,174,109',
		secondary: '210,174,109',
	},
	language: 'en',
	company_details: {},
	modal_open: false,
});
export const getters = {
	getTheme: (state: any) => state.theme,
	getLanguage: (state: any) => state.language,
	getModalOpen: (state: any) => state.modal_open,
	getUniversityTheme: (state: any) => state.university_theme,
};
export const mutations = {
	setTheme(state: any, payload: any) {
		state.theme = payload;
	},
	setLanguage(state: any, payload: any) {
		state.language = payload;
	},
	setModalOpen(state: any, payload: any) {
		state.modal_open = payload;
	},
	setUniversityTheme(state: any, payload: any) {
		state.university_theme = payload;
	},
};
export const actions = {
	setTheme(state: any, payload: any) {
		state.commit('setTheme', payload);
	},
	setLanguage(state: any, payload: any) {
		state.commit('setLanguage', payload);
	},
	updateModalOpen(state: any, payload: any) {
		state.commit('setModalOpen', payload);
	},
	updateUniversityTheme(state: any, payload: any) {
		state.commit('setUniversityTheme', payload);
	},
};
